import { PulseLoader } from "react-spinners";

const FallbackLoading = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <PulseLoader color="var(--primary-color)" />
    </div>
  );
};

export default FallbackLoading;
